import {Terno} from '../types'
import {data} from '../data'

const ternos = (
    state: Terno[] = data[0].ternos
) => {
    return state
}

export default ternos